import {Party} from "../api/types/Party";
import {Question} from "../api/types/Question";
import {ViewQuestion} from "../api/types/ViewQuestion";
import {Preset} from "../api/types/Preset";
import {QuestionGroup} from "../api/types/QuestionGroup";
import {View} from "../api/types/View";
import {StatusUpdateAnswer} from "./UpdatePartyObject";
import {Answer} from "../api/types/Answer";
import {Attachment} from "../api/types/Attachment";

export interface AppParty extends Party {
    presets: AppPreset[];
}

export interface AppQuestion extends Question {
    hidden: boolean,
    answers: AppAnswer[]
}

export interface AppViewQuestion extends ViewQuestion {
    hidden: boolean,
    answers: AppAnswer[]
}

export interface AppPreset extends Preset {
    items: Array<AppQuestion | AppQuestionGroup>;
}

export interface AppQuestionGroup extends QuestionGroup {
    views: AppView[];
    hidden: boolean;
}

export interface AppView extends View {
    questions: AppViewQuestion[];
}

export interface AppAnswer extends Answer {
    status: StatusUpdateAnswer,
    errorText?: string,
    attachments: AppAttachment[]
}

export interface AppAttachment extends Attachment {
    order: number,
    status: StatusUpdateAnswer
}

export const IsQuestionGroup = (question: AppQuestionGroup | AppQuestion): question is AppQuestionGroup => {
    return (question as QuestionGroup).views !== undefined;
}